<template>
  <div class="heim-user-card">
    <div class="cell profile">
      <span class="avatar">{{user.name.charAt(0).toUpperCase()}}</span>
    </div>
    <div class="cell info">
      <span class="label">{{user.name}}</span>
      <div class="email"><router-link to="/">{{user.email}}</router-link></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "heim-user-card",
  props: {
    user: Object
  }
};
</script>

<style scoped>
.heim-user-card {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 8px;
  padding: 0.4rem;
}
.heim-user-card:hover {
  background-color: var(--heim-grey-color);
}

.cell {
  padding: 0.3rem 0.5rem;
}

.heim-user-card .info {
  flex: 1;
}

.heim-user-card .info .email {
  font-size: 0.8rem;
  font-weight: 600;
  word-break: break-word;
}

.heim-user-card .avatar {
  font-size: 1.5rem;
  font-weight: 600;
  background-color: var(--heim-secondary-color);
  color: var(--heim-white-color);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  border: solid thin var(--heim-grey-color);
  cursor: default;
}

.remove .paper-action {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.heim-user-card .info .label {
  font-size: 1.2em;
  font-weight: 400;
}
</style>
